export default function updatePageTitle(title: string) {
    const element = document.createElement('div');
    element.innerHTML = title;

    document.title = element.textContent?.trim() || '';
}
